// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "mat-form-field {\n  font-size: 12px;\n}", "",{"version":3,"sources":["webpack://./src/app/pages/formulario-bingo/formulario-bingo.component.scss"],"names":[],"mappings":"AAAA;EACC,eAAA;AACD","sourcesContent":["mat-form-field{\r\n\tfont-size: 12px;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
